import { useEffect } from 'react'
import { DecodedValueMap, StringParam, useQueryParams } from 'use-query-params'
import { sharedQueryParams, DashboardParamsState } from './sharedQueryParams'

export const dashboardQueryParams = {
  ...sharedQueryParams,
  project: StringParam,
  runId: StringParam,
  traceFile: StringParam,
}

export type DashboardQueryParams = typeof dashboardQueryParams

export type DashboardQueryParamValues = DecodedValueMap<DashboardQueryParams>

export const useDashboardParams =
  (): DashboardParamsState<DashboardQueryParams> => {
    const [query, setQuery] = useQueryParams(dashboardQueryParams)

    useEffect(() => {
      // replaceIn to avoid adding unnecessary history entry
      setQuery({ suite: query.suite }, 'replaceIn')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { query, setQuery }
  }
